<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-9">
        <article class="entry" v-for="item in blogs" :key="item.id">
          <div class="entry-media" v-if="item.imageUrl">
            <router-link :to="{ name: 'Blog', params: { id: item.id, slug: slugify(item.title) } }">
              <img
                :src="`${baseUrl}${item.imageUrl}`"
                alt="Post image"
              />
            </router-link>
          </div>
          <div class="entry-body">
            <div class="entry-date">
              <span class="day">{{ formatDate(item.createdDate, 'dd') }}</span>
              <span class="month">{{ formatDate(item.createdDate, 'MMM') }}</span>
            </div>
            <!-- End .entry-date -->
            <h2 class="entry-title">
              <router-link
              :to="{ name: 'Blog', params: { id: item.id, slug: slugify(item.title) } }">
                {{ item.title }}
              </router-link>
            </h2>
            <div class="entry-content">
              <div class="html-content" v-html="item.shortDescription">
              </div>
              <router-link
                class="read-more"
                :to="{ name: 'Blog', params: { id: item.id, slug: slugify(item.title) } }"
              >
                {{ translations.readMore }} <i class="icon-angle-double-right"></i>
              </router-link>
            </div>
            <!-- End .entry-content -->
            <div class="entry-meta">
              <span><i class="icon-calendar"></i>
                {{ formatDate(item.createdDate, 'MMMM dd, yyyy') }}
              </span>
            </div>
            <!-- End .entry-meta -->
          </div>
          <!-- End .entry-body -->
        </article>
        <!-- End .entry -->

        <pagination :action="actionName" />
      </div>
      <!-- End .col-lg-9 -->
      <aside class="sidebar col-lg-3">
        <div class="sidebar-wrapper">
          <div class="widget widget-search">
            <form class="search-form" @submit.prevent="handleSearch">
              <input
                type="text"
                class="search-term form-control"
                placeholder="Search"
                v-model="searchTerm"
              />
              <button type="submit" class="search-submit" title="Pretraga">
                <i class="icon-search"></i>
                <span class="sr-only">{{ translations.searchFor }}</span>
              </button>
            </form>
          </div>
          <!-- End .widget -->
          <div class="widget">
            <h4 class="widget-title">{{ translations.recentBlogs }}</h4>
            <ul class="simple-entry-list">
              <li v-for="item in recentBlogs" :key="item.id">
                <div class="entry-media" v-if="item.imageUrl">
                  <router-link
                  :to="{ name: 'Blog', params: { id: item.id, slug: slugify(item.title) } }">
                  <img
                    :src="`${baseUrl}${item.imageUrl}`"
                    alt="Post"
                  />
                  </router-link>
                </div>
                <!-- End .entry-media -->
                <div class="entry-info">
                  <router-link
                  :to="{ name: 'Blog', params: { id: item.id, slug: slugify(item.title) } }">
                    {{ item.title }}
                  </router-link>
                  <div class="entry-meta">{{ formatDate(item.createdDate, 'MMMM dd, yyyy') }}</div>
                  <!-- End .entry-meta -->
                </div>
                <!-- End .entry-info -->
              </li>
            </ul>
          </div>
          <!-- End .widget -->
          <!-- <div class="widget">
            <h4 class="widget-title">Tagovi</h4>
            <div class="tagcloud">
              <a href="#">Kuhinja</a>
              <a href="#">Hoteli</a>
              <a href="#">Restorani</a>
              <a href="#">Podovi</a>
              <a href="#">Čistoća</a>
            </div>
          </div> -->
          <!-- End .widget -->
          <div class="widget">
            <h4 class="widget-title">{{ translations.archive }}</h4>
            <ul class="list">
              <li
                v-for="(month, index) in lastThreeMonths"
                :key="index"
                @click.prevent.stop="getBlogsByDate(month.getMonth() + 1, month.getFullYear())"
              >
                <a href="#">
                  {{ formatDate(month, 'MMMM yyyy') }}
                </a>
              </li>
            </ul>
          </div>
          <!-- End .widget -->
        </div>
        <!-- End .sidebar-wrapper -->
      </aside>
      <!-- End .col-lg-3 -->
    </div>
  </div>
  <!-- End .row -->
</template>

<script>
import { pager, translations } from '@/mixins';
import helpers from '@/services/helpers';
import config from '@/config';
import slugify from '@/filters/slugify';

import Pagination from '@/components/shared/Pagination.vue';

export default {
  components: { Pagination },
  name: 'Blogs',
  mixins: [pager, translations],
  comments: {
    Pagination,
  },
  data() {
    return {
      actionName: 'getBlogs',
      searchTerm: '',
    };
  },
  computed: {
    baseUrl() {
      return config.baseUrl;
    },
    blogs() {
      return this.$store.getters.getBlogs;
    },
    recentBlogs() {
      return this.$store.getters.getRecentBlogs;
    },
    lastThreeMonths() {
      const currentDate = new Date();

      return [
        currentDate,
        new Date(new Date(currentDate).setMonth(currentDate.getMonth() - 1)),
        new Date(new Date(currentDate).setMonth(currentDate.getMonth() - 2)),
      ];
    },
  },
  methods: {
    slugify,
    formatDate: helpers.formatDate,
    getBlogsByDate(month, year) {
      this.$store.dispatch(this.actionName, {
        ...this.searchConfig,
        page: 1,
        month,
        year,
      });
    },
    handleSearch() {
      this.$store.dispatch(this.actionName, {
        ...this.searchConfig,
        quickSearch: this.searchTerm.trim(),
      });
    },
  },
  mounted() {
    this.$store.dispatch(this.actionName, this.searchConfig);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getRecentBlogs');
  },
};
</script>
<style scoped>
.html-content a {
  color: #3598DB;
}
</style>
